import React from 'react'
import FormROValue from '../../../../../library/form/components/FormROValue1';
import FormLink from '../../../../../library/form/components/FormLink';
import SarasButton2 from '../../../../../library/input/buttons/button/SarasButton2';
import { Icon } from '../../../../../library/decor/SarasIcons';
//import SarasTrans from '../../../../../library/notifications/SarasTrans';
import ProdIOListQtyCell, { ProdIOListUnitCell } from './ProdIOListQtyCell';

const ProdIOOSumViewRow = (props) => {
    const { formObject, viewData, rowKey, groupedMode, canExpand, expanded, onToggle, showBatchId, leadingIconKey, rowClassName } = props;

    const rowCss = formObject.getValueFromKey(viewData, "dataList.cssClass", "");
    const LeadingIcon = leadingIconKey ? (Icon[leadingIconKey]) : null;

    return (
        <ul className={`uiDPEditLine ${rowCss} ${rowClassName || ''}`}>
            <li className="uiColumn uiColumnLeft uiColumn130">
                <div className="uiFlexBox">
                    {groupedMode ? (
                    <span className="uiFlexBox" style={{ width: '32px', minWidth: '32px', alignItems: 'center' }}>
                        {canExpand ? (
                            <SarasButton2
                                icon={expanded ? 'collapse2' : 'expand2'}
                                onClick={() => onToggle(rowKey)}
                                containerClass="uiFlexBox"
                                className="uiDefaultIconButton"
                            />
                        ) : LeadingIcon ? (
                            <LeadingIcon className="uiDefaultIconButton" />
                        ) : null}
                    </span>
                    ) : null}
                    <span className="uiFlexBox">
                        <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "id" }} />
                    </span>
                </div>
            </li>
            {groupedMode ? (
                <li className="uiColumn uiColumnLeft uiColumn350">
                    <div className="uiFlexBox">
                        <FormLink formObject={formObject} rowKey={rowKey} kscFormula=""
                            prefix={showBatchId ? "Batch :" : ""}
                            useVal={showBatchId ? 1 : 0}
                            className="uiFlexBox uiLink"
                            action={{
                                paramName: "actualItem",
                                actionId: "show", actionName: "itemComp",
                                containerKey: "custom",
                                actionParam: { showModeID: "qv" }
                            }}
                            linkProp={{ target: "_blank" }}
                        ></FormLink>
                    </div>
                </li>
            ) : (
                <li className="uiColumn uiColumnLeft uiColumn350">
                    <FormLink formObject={formObject} rowKey={rowKey} kscFormula=""
                        action={{
                            paramName: "actualItem",
                            actionId: "show", actionName: "itemComp",
                            containerKey: "custom",
                            actionParam: { showModeID: "qv" }
                        }}
                        linkProp={{ target: "_blank" }}
                    ></FormLink>
                </li>
            )}
            <ProdIOListUnitCell formObject={formObject} rowKey={rowKey} param1="unit1" param2="unit2" />
            <ProdIOListQtyCell formObject={formObject} rowKey={rowKey} param1="qtyRequired1" param2="qtyRequired2" />
            <ProdIOListQtyCell formObject={formObject} rowKey={rowKey} param1="qtyAllocated1" param2="qtyAllocated2" className="uiColumnGroupSplit" />
            <ProdIOListQtyCell formObject={formObject} rowKey={rowKey} param1="qtyRequested1" param2="qtyRequested2" />
            <ProdIOListQtyCell formObject={formObject} rowKey={rowKey} param1="qtyReceived1" param2="qtyReceived2" />
            <ProdIOListQtyCell formObject={formObject} rowKey={rowKey} param1="qtyBalance1" param2="qtyBalance2" />
            <ProdIOListQtyCell formObject={formObject} rowKey={rowKey} param1="qtyReturnedToStock1" param2="qtyReturnedToStock2" className="uiColumnGroupSplit"/>
            <ProdIOListQtyCell formObject={formObject} rowKey={rowKey} param1="qtyWithWorker1" param2="qtyWithWorker2" />
            <ProdIOListQtyCell formObject={formObject} rowKey={rowKey} param1="qtyConsumed1" param2="qtyConsumed2" />
            <ProdIOListQtyCell formObject={formObject} rowKey={rowKey} param1="qtyWasted1" param2="qtyWasted2" className="uiColumnGroupSplit"/>
        </ul>
    )
}

export default ProdIOOSumViewRow
